export default function Tracking(app) {
    app.api.Tracking = Object.freeze({
        navigation,
        event
    })


    /* ------------- PIWIK PRO CUSTOM EVeNT TRACKING ------------- */
    // Array containing a tracking function’s name followed by its arguments. The number of arguments and their meaning are determined by the tracking function.
    // ["trackEvent", "video", "video-paused", "intro.mp4", 15.2];

    /* Custom events
        trackEvent(category, action[, name[, value[, dimensions]]])
        Tracks custom event, e.g. when visitor interacts with the page.

        Arguments:	
        category (string) – Required Event category
        action (string) – Required Event action
        name (string) – Optional Event name
        value (number) – Optional Event value
        dimensions (object) – Optional Custom dimensions to pass along with the custom event
    */

    // Navigation with hooks in the $Router
    function navigation(action, property, payload) {
    
        //console.log("Navigation payload:", payload);

        let folder = "/future-spin"
        let root = location.protocol + "//" + location.host + folder;
        let title = payload.to.split("/").pop().split("-").join(" ");

        let data = {
            event: 'spa_pageview',
            spa_page_location: root + payload.to,
            spa_page_path: folder + payload.to,
            spa_page_title: title,
            spa_page_referrer: (payload.from!="") ? root + payload.from : null
        }

        console.log("Navigation payload from:", payload.from);
        

        // if (title == "" )
        //     return;


        console.log(data);
        CreateLog(data);
    }

    // Explicitly called events with js (buttonclicks etc.)
    function event(action, property, payload) {

        // feb '26 : piwik pro disabled - GTM tracking added for future spin level choice event
        // currently only called from wheelNavigation.vue 

        CreateLog(payload);
    }

    function CreateLog(data) {

        //console.log(data);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }
}